module.exports = __webpack_public_path__ + "static/media/main-bk-fenix.44248268.png";